import React from "react";
import {withTranslation} from "react-i18next";
import { Link } from 'react-router-dom';
import RoutePath from '../../resource/RoutePath'
import { findTimeString } from "../../common/Util";

class MFLSpaceComp  extends React.Component {
	constructor(props) {
        super(props);
		this.state = {
		};
	}
	render() {
		const {t} = this.props;
		
		return (
			<div className="content-wrap sub-content">
				<div className="visual-slide-wrap">
					<div className="visual-slide-list">
						<div className="slide">
							<div className="img">
								<img src="https://asset.981park.com/www/common/mweb/img/sub/play/slide-space-zero1.png" alt="9.81 파크의 대표 액티비티, 친환경 그래비티 레이싱!"/>
							</div>
						</div>			
					</div>
					<div className="visual-slide-text">
						<div className="inner">
							<div className="con">
								<div className="text-wrap color1">
									<p className="s-text typo1">SPACE ZERO</p>
									<p className="m-text">{t('FLSpaceComp_m_title_1')}<br/>{t('FLSpaceComp_m_title_2')}<br/>{t('FLSpaceComp_m_title_3')}</p>
								</div>
							</div>	
						</div>	
					</div>
				</div>
				<div className="detail-con-wrap">
					<div className="inner">
						<div className="list">
							<div className="list-con">
								<p className="lg-ttl">{t('FLSpaceComp_c_title_1')}</p>
								<div className="img">
									<img src="https://asset.981park.com/www/common/mweb/img/sub/play/img-space-zero1.png" alt="space zero"/>
								</div>
								<div className="txt-wrap">
									<div className="txt">
										{t('FLSpaceComp_c_sub_1_1')}
										{t('FLSpaceComp_c_sub_1_2')}
										{t('FLSpaceComp_c_sub_1_3')}
									</div>
								</div>
							</div>	
							
							<div className="list-con">
								<p className="lg-ttl">{t('FLSpaceComp_c_title_2')}</p>
								<div className="list-txt">						
									<ul>
										<li>
											<p className="txt">
											{t('FLSpaceComp_c_sub_2_1')}
											</p>
										</li>
									</ul>
								</div>
								<div className="button-wrap">
									<Link to={`/`+RoutePath.PARKFLEX} className="link-detail-more">{t('FLSpaceComp_c_sub_2_3')}</Link>
								</div>
							</div>	
														
							<div className="list-con">
								<p className="lg-ttl">{t('FLSpaceComp_c_title_4')}</p>
								<div className="list-txt">						
									<ul>
										<li>
											<p className="txt">
												{t('FLSpaceComp_c_sub_4_1')}<br/>
												{t('FLSpaceComp_c_sub_4_2')}
											</p>
										</li>
									</ul>
								</div>
							</div>	
							
							<div className="list-con">
								<p className="lg-ttl">{t('OperationComp_c_title_4')}</p>
								<div className="button-wrap">
									<Link to={`/`+RoutePath.OPERATION} style={{cursor: "pointer"}} className="link-detail-more">{t('OperationComp_c_title_4_2')}</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default withTranslation()(MFLSpaceComp);